<template>
  <section v-if="items.length" class="py-16" :id="id">
    <div class="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <h2 v-if="heading" class="text-3xl font-semibold tracking-[-0.02em] text-ink md:text-4xl">
        {{ heading }}
      </h2>
      <p v-if="subheading" class="mt-3 text-[17px] text-ink-2">
        {{ subheading }}
      </p>
      <div class="mt-8 divide-y divide-line border-y border-line">
        <details
          v-for="(item, idx) in items"
          :key="idx"
          class="group py-5"
        >
          <summary
            class="flex cursor-pointer list-none items-center justify-between text-left text-[17px] font-medium text-ink group-hover:text-accent"
          >
            <span>{{ item.question }}</span>
            <svg
              class="ml-4 h-5 w-5 flex-none transform text-ink-4 transition-transform duration-200 group-open:rotate-180"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </summary>
          <p class="mt-3 max-w-3xl leading-relaxed text-ink-2">{{ item.answer }}</p>
        </details>
      </div>
    </div>
    <JsonLd :data="schema" />
  </section>
</template>


<script setup lang="ts">
import { computed } from 'vue'
import JsonLd from './JsonLd.vue'

export interface FaqItem {
  question: string
  answer: string
}

const props = defineProps<{
  items: FaqItem[]
  heading?: string
  subheading?: string
  id?: string
}>()

const schema = computed(() => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: props.items.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
}))
</script>
